import clsx from 'clsx'

import { Skeleton } from './Skeleton'

export type PageTabsSkeletonProps = {
  className?: string
  count?: number
}

/**
 * Trilho de abas (`PageTabs` / `ScheduleDayTabs`) durante carregamento.
 */
export const PageTabsSkeleton = ({
  className,
  count = 4
}: PageTabsSkeletonProps) => (
  <div
    className={clsx(
      'rounded-[var(--radius-card-standard,14.4px)] bg-white p-1 shadow-sm',
      className
    )}
    aria-hidden
  >
    <div className="flex gap-1">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} variant="pill" className="h-9 min-w-0 flex-1" />
      ))}
    </div>
  </div>
)
